/*
 * API do Projeto
 */


declare var firebase;

class Const {

  //api = 'http://localhost:8080/v1/';

  api = 'https://winvite-io.appspot.com/v1/';
  //api = 'https://teste-hdm-dot-winvite-io.appspot.com/v1/';
  //api = 'https://nelson-dot-winvite-io.appspot.com/v1/';

  path = {
    home: "home",
    ngos: "ngos",
    assets: "assets",
    hallOfFame: "hallOfFame",
    profiles: "profiles",
    transfer: "transfer",
    buyAsset: "buyAsset",
    confirmBuy: "confirmBuy",
    ticker: "ticker",
    tfa: "tfa",
    deposit: "deposit",
    company: "company",
    auction: "auction",
    donation: "donation",
  };

  authorization = "Bearer ";

  constructor() {
  	
  	//debugger;
  	
    let token = localStorage.getItem("token");

    if (firebase.auth().currentUser && firebase.auth().currentUser.ra) {
	    
      this.authorization += firebase.auth().currentUser.ra;
      localStorage.setItem("token", firebase.auth().currentUser.ra);
    } else if (token) {
      this.authorization = "Bearer " + token;
    }

    firebase.auth().onIdTokenChanged(user => {
	    
      if (user && user.ra) {
	      
        localStorage.setItem("token", user.ra);
        this.authorization = "Bearer " + user.ra;
      }
    });

    firebase.auth().onAuthStateChanged(user => {

      if (user && user.ra) {
	      
        this.authorization = "Bearer " + user.ra;
        localStorage.setItem("token", user.ra);
      }
    });
  }
}

export default new Const();



// WEBPACK FOOTER //
// ./src/utils/consts.js